import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { css } from "@nju/css";
import { useUser } from "@nju/data-access-portal-user";
import { pushSimpleEvent } from "@nju/data-layer";
import { ErrorMessage } from "@nju/form";
import { Icon } from "@nju/icons";
import { BlockText, Box, Button, Panel, Separator } from "@nju/ui";
import { registerCreditCardMachine } from "../machines/registerCreditCardMachine";

export function NoCardBanner() {
  const router = useRouter();
  const { id: userId } = useUser();

  const [{ matches, context }, send] = useMachine(registerCreditCardMachine, {
    actions: {
      onSubmitSuccess: (_, event) => {
        pushSimpleEvent({
          event: "activity_service",
          eventName: "payment_add_cart",
        });

        if (event.type !== "CARD_REGISTERED") {
          return;
        }
        if (event.data.transactionLink === "MOCK") {
          setTimeout(() => {
            return router.reload();
          }, 2000);
        } else {
          window.location.assign(event.data.transactionLink);
        }
      },
    },
    context: {
      userId,
    },
  });

  const handleAddCard = React.useCallback(() => {
    send("SUBMIT");
  }, [send]);

  const { registrationError } = context;
  return (
    <Panel testId="no-credit-card-banner">
      <Box className={styles.content()} display="flex" flexDirection="column">
        <Box display="flex" justify="center">
          <Icon className={styles.image()} name="credit-card-incircle-fail" />
        </Box>
        <BlockText
          align="center"
          className={styles.text()}
          size={{ "@onlyMobile": "s", "@fromTablet": "m" }}
        >
          brak karty płatniczej
        </BlockText>
        <div className={styles.buttonWrapper()}>
          {registrationError && (
            <>
              <ErrorMessage message={registrationError} />
              <Separator size="xxs" tone="invisible" />
            </>
          )}
          <Button
            display="block"
            isLoading={!matches("ready")}
            onPress={handleAddCard}
            size={{ "@onlyMobile": "s" }}
            variant="secondary"
          >
            dodaj kartę
          </Button>
        </div>
      </Box>
    </Panel>
  );
}

const styles = {
  text: css({
    mt: "$10",
    mb: "$15",
    "@fromTablet": {
      mt: "$15",
      mb: "$25",
    },
  }),
  image: css({
    width: "60px",
    height: "60px",
    "@fromTablet": {
      width: "90px",
      height: "90px",
    },
  }),
  buttonWrapper: css({
    mt: "auto",
  }),
  content: css({
    height: "100%",
  }),
};
